export var ChatPanelForms;
(function (ChatPanelForms) {
    ChatPanelForms["LanguageCustomizationPageForm"] = "ChatCsatLanguageCustomizationPageForm";
    ChatPanelForms["GlobalSettingsForm"] = "ChatCsatGlobalSettingsForm";
})(ChatPanelForms || (ChatPanelForms = {}));
